import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-407d5bb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_3 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_5 = { class: "py-4 px-5 md:px-6 border-b flex justify-between items-center flex-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg md:text-2xl font-medium text-gray-900" }, "Short list templates", -1))
const _hoisted_7 = { class: "p-5 md:p-6" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "border rounded-lg divide-y overflow-scroll",
  style: {"max-height":"310px"}
}
const _hoisted_10 = { class: "font-medium" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-sm mt-2 text-gray" }
const _hoisted_13 = { class: "hidden-menu shrink-0 w-48 flex justify-end" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "shrink-0 bg-sky text-white px-3 py-1 rounded-md text-sm"
}, " Import ", -1))
const _hoisted_15 = { class: "menu flex items-center space-x-2" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("button", {
              type: "button",
              class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('ModalImportList')))
            }, [
              _createVNode(_component_XIcon, { class: "w-5 h-5" })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.templates.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "You don't have any templates saved yet"))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, ({ name, description, id, originators}, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex justify-between items-center px-4 py-3",
                      key: id
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(name), 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", {
                            class: "text-blue-500 cursor-pointer",
                            title: "Preview",
                            onClick: ($event: any) => (_ctx.showModal('ModalShortList', { data: _ctx.templates[index] }))
                          }, " (" + _toDisplayString(originators.length) + " entries) ", 9, _hoisted_11)
                        ]),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(description), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "border text-sm rounded-md px-3 py-1 hover:bg-gray-100",
                            onClick: ($event: any) => (_ctx.bulkUpdateOriginatorsList({ name, originators }, false, 'ModalImportList'))
                          }, " Replace ", 8, _hoisted_16),
                          _createElementVNode("button", {
                            type: "button",
                            class: "border text-sm rounded-md px-3 py-1 hover:bg-gray-100",
                            onClick: ($event: any) => (_ctx.bulkUpdateOriginatorsList({ name, originators }, true, 'ModalImportList'))
                          }, " Merge ", 8, _hoisted_17)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
          ])
        ])
      ])
    ])
  ]))
}